import React from "react";
import "./styles/index.css";
import "./styles/App.css";
import NavBar from "./Components/Navbar";
import Hero from "./Components/Hero";
import Skills from "./Components/Skills";
import Index from "./Pages/Index";

function App() {
  return (
    <>
      <Index />
    </>
  );
}

export default App;
